/**
 * Parallax effect for a single image
 */

const mvParallax = () => {
  const mvImage = document.querySelector('.js-mv-parallax') as HTMLElement;

  if (mvImage) { // Check if the image is available
    window.addEventListener('scroll', () => {
      const scrollPosition = window.scrollY; // Get the scroll position
      mvImage.style.transform = `translateY(${scrollPosition * 0.5}px)`; // Apply the parallax effect
    });
  }
};

export default mvParallax;
